/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_Logo_AltInputs */

const en_landing_nav_logo_alt = /** @type {(inputs: Landing_Nav_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 logo`)
};

const zh_landing_nav_logo_alt = /** @type {(inputs: Landing_Nav_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 标志`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 logo" |
*
* @param {Landing_Nav_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_nav_logo_alt = /** @type {((inputs?: Landing_Nav_Logo_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_Logo_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_logo_alt(inputs)
	return zh_landing_nav_logo_alt(inputs)
});
export { landing_nav_logo_alt as "landing.nav.logo_alt" }